import { createReducer } from 'typesafe-actions';
import { fetchSimpleProduct } from './actions';

const simpleProductInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    // TODO PB Ask about business logic which better default closed or opened bookstore.
    data: null,
};

const simpleProductReducer = createReducer(simpleProductInitialState)
    .handleAction(fetchSimpleProduct.request, (state) => ({ ...state, isLoading: true }))
    .handleAction(fetchSimpleProduct.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchSimpleProduct.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
    }));

export default simpleProductReducer;
